import Modal from '../../Modal/Modal';
import { ChooseRegisterModalProps } from './ChooseRegisterModal.types';
import ChooseRegisterModalForm from './ChooseRegisterModalForm/ChooseRegisterModalForm';

export default ({ ...props }: ChooseRegisterModalProps) => {
  return (
    <Modal style={{ alignItems: 'unset' }} {...props}>
      <h2
        style={{
          fontFamily: 'Quicksand-Bold',
          marginLeft: 'var(--spacing-m)',
          marginRight: 'var(--spacing-m)',
        }}>
        Je souhaite <span className="text-primary">m'inscrire</span> en tant que...
      </h2>
      <ChooseRegisterModalForm />
    </Modal>
  );
};
